import {Component, OnDestroy, OnInit} from '@angular/core';
import {Field} from "../models/field.model";
import {DateTimeAdapter} from 'ng-pick-datetime';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
	selector: "tig-form-date",
	template: `
		<div
			class="form-group"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div class="col-lg-8">
				<input
					class="form-control"
					[formControlName]="OBJ_field_config.name"
					[placeholder]="getLabelName()|translate"
					[owlDateTimeTrigger]="dt"
					[owlDateTime]="dt"
					[selectMode]="OBJ_field_config?.selectMode?OBJ_field_config.selectMode:'single'"
					(dateTimeChange)="dateTimeChange($event)"
				> <i
				class="fa fa-calendar tig-calendar"
				[owlDateTimeTrigger]="dt"
				[disabled]="OBJ_field_config?.readonly"></i>
				<owl-date-time
					#dt
					[pickerType]="OBJ_field_config?.datepicker_type?OBJ_field_config?.datepicker_type:'both'"
					[stepMinute]="OBJ_field_config?.steps?.minute?OBJ_field_config?.steps?.minute:1"
					[stepHour]="OBJ_field_config?.steps?.hour?OBJ_field_config?.steps?.hour:1"
					[stepSecond]="OBJ_field_config?.steps?.second?OBJ_field_config?.steps?.second:1"
					[startAt]=startAt
				></owl-date-time>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
				<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
			</div>
		</div>
	`
})
export class FormDateComponent extends Field implements OnInit, OnDestroy
{

	ngOnInit(): void
	{
		// Wenn bereits ein Wert vergeben wurde, so soll kejn Startdatum fuer den Datepicker gewählt werden
		if(this.OBJ_field_config.value)
		{
			this.startAt = null;
		}
		// Soll Datepicker zu bestimmter Uhrzeit starten? Ansonsten nimmt er immer now
		else if (this.OBJ_field_config.start_at)
		{
			if (this.OBJ_field_config.start_at.hour !== undefined)
			{
				this.startAt.setHours(this.OBJ_field_config.start_at.hour);
			}

			if (this.OBJ_field_config.start_at.minute !== undefined)
			{
				this.startAt.setMinutes(this.OBJ_field_config.start_at.minute);
			}
			if (this.OBJ_field_config.start_at.second !== undefined)
			{
				this.startAt.setSeconds(this.OBJ_field_config.start_at.second);
			}
			else
			{
				// Sekunden beginnen immer bei 0, sondern nicht anders konfiguriert
				this.startAt.setSeconds(0);
			}
		}
		else
		{
			// Sekunden beginnen immer bei 0, sondern nicht anders konfiguriert
			this.startAt.setSeconds(0);
		}

	}

	/**
	 * Attributes
	 * @see https://www.npmjs.com/package/ng-pick-datetime
	 */
	private ARR_subscriptions: Subscription[] = [Subscription.EMPTY];
	public startAt = new Date();
	// TODO: Aktuell Validatoren für min und maxdate noch nicht verbaut, wäre aber prinzipiell möglich
	// min = '2018-02-04T08:47:56.000Z';

	/**
	 * Function > constructor
	 */
	constructor(private dateTimeAdapter: DateTimeAdapter<any>, private OBJ_translate_service: TranslateService)
	{

		super();
		dateTimeAdapter.setLocale(this.OBJ_translate_service.currentLang);
		this.ARR_subscriptions.push(this.OBJ_translate_service.onLangChange.subscribe((OBJ_lang_change_event: LangChangeEvent) => {
			dateTimeAdapter.setLocale(this.OBJ_translate_service.currentLang);
		}));

	} // end function constructor

	/**
	 * LifecycleHook > ngOnDestroy
	 */
	ngOnDestroy()
	{
		// Unsubscribe from all subscriptions to prevent memory leak
		this.ARR_subscriptions.forEach((OBJ_subscription: Subscription) => {
			OBJ_subscription.unsubscribe();
		});
	} // end LifecycleHook ngOnDestroy

	/**
	 * Function  dateTimeChange
	 *
	 * @desc setzte Wert manuell, da ngModel so nicht mehr geht
	 * @param event
	 */
	dateTimeChange(event: any)
	{

		super.setValue(event.value);
	}

} // end class FormDateComponent
